import React, { useState } from 'react';
import $ from 'jquery';
import { GenerateHtmlMarkup } from "../../widgets/generateHtmlMarkup";

const sliderStyles = {
	position: "relative",
};

const dotsContainerStyles = {
	display: "flex",
	justifyContent: "center",
};

const ImageSlider = ({ slides, sliderDimensions, imageHeights, imageWidths }) => {
	if (typeof sliderDimensions === "undefined") {
		sliderDimensions = {height: 0, width: 0};
	}
	const width = sliderDimensions.width;
	const height = sliderDimensions.height;

	const [currentIndex, setCurrentIndex] = useState(0);
	const goToPrevious = () => {
		const isFirstSlide = currentIndex === 0;
		const newIndex = isFirstSlide ? slides.length - 1 : currentIndex - 1;
		setCurrentIndex(newIndex);
	};
	const goToNext = () => {
		const isLastSlide = currentIndex === slides.length - 1;
		const newIndex = isLastSlide ? 0 : currentIndex + 1;
		setCurrentIndex(newIndex);
	};
	const goToSlide = (slideIndex) => {
		setCurrentIndex(slideIndex);
	};
	const currentSlide = slides[currentIndex];
	// const currentHeight = imageHeights[currentIndex];
	// const currentWidth = imageWidths[currentIndex];
	return (
		<div class="slider" style={sliderStyles}>
			<div>
				{currentIndex === 0 ? "" :
					<div onClick={goToPrevious}>
						<button class="previous-slide">
							<div class="direction-icon"></div>
							<span class="screen-reader">Go to Slide</span>
						</button>
					</div>
				}
				{currentIndex === slides.length - 1 ? "" :
					<div onClick={goToNext}>
						<button class="next-slide">
							<div class="direction-icon"></div>
							<span class="screen-reader">Go to Slide</span>
						</button>
					</div>
				}
			</div>
			<GenerateHtmlMarkup tag={'div'} id={'current-slide'} class="current-slide" 
				style={{/*
					height: currentHeight > sliderDimensions.height ? sliderDimensions.height : currentHeight,
					width: currentWidth >= sliderDimensions.width ? "" : currentWidth
				*/}}
				htmlMarkup={currentSlide} />
			{/*<div class="slide-caption">{$(slides[currentIndex]).find('figcaption').text()}</div>*/}
			<div class="dots-container" style={dotsContainerStyles}>
				{slides.map((slide, slideIndex) => (
					<div
						class={slideIndex === currentIndex ? "dot active" : "dot"}
						key={slideIndex}
						onClick={() => goToSlide(slideIndex)}
					>
						●
					</div>
				))}
			</div>
		</div>
	);
};

export default ImageSlider;